"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AttachmentsService", {
    enumerable: true,
    get: function() {
        return AttachmentsService;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _url = /*#__PURE__*/ _interop_require_default(require("url"));
const _stream = require("stream");
const _nocodbsdk = require("nocodb-sdk");
const _common = require("@nestjs/common");
const _nanoid = require("nanoid");
const _lite = /*#__PURE__*/ _interop_require_default(require("mime/lite"));
const _slash = /*#__PURE__*/ _interop_require_default(require("slash"));
const _pqueue = /*#__PURE__*/ _interop_require_default(require("p-queue"));
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _objecthash = /*#__PURE__*/ _interop_require_default(require("object-hash"));
const _moment = /*#__PURE__*/ _interop_require_default(require("moment"));
const _requestfilteringagent = require("request-filtering-agent");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _mimeTypes = require("~/utils/mimeTypes");
const _models = require("~/models");
const _stringHelpers = require("~/helpers/stringHelpers");
const _catchError = require("~/helpers/catchError");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _Jobs = require("~/interface/Jobs");
const _globals = require("~/utils/globals");
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
const _attachmentUtils = require("~/utils/attachmentUtils");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _useworkerdecorator = require("~/decorators/use-worker.decorator");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
// ref: https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html - extended with some more characters
const normalizeFilename = (filename)=>{
    return filename.replace(/[\\/:*?"<>'`#|%~{}[\]^]/g, '_');
};
let AttachmentsService = class AttachmentsService {
    async upload(param) {
        var _param_req_user, _param_req, _param_path_toString, _param_path, _param_files, _param_files1;
        // Validate scope if exist
        if (param.scope && !Object.values(_nocodbsdk.PublicAttachmentScope).includes(param.scope)) {
            _catchError.NcError.invalidAttachmentUploadScope();
        }
        const userId = ((_param_req = param.req) == null ? void 0 : (_param_req_user = _param_req.user) == null ? void 0 : _param_req_user.id) || 'anonymous';
        param.path = param.scope ? `${(0, _objecthash.default)(userId)}` : param.path || `${(0, _moment.default)().format('YYYY/MM/DD')}/${(0, _objecthash.default)(userId)}`;
        // TODO: add getAjvValidatorMw
        const _filePath = this.sanitizeUrlPath(((_param_path = param.path) == null ? void 0 : (_param_path_toString = _param_path.toString()) == null ? void 0 : _param_path_toString.split('/')) || [
            ''
        ]);
        const _destPath = _path.default.join('nc', param.scope ? param.scope : 'uploads', ..._filePath);
        const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
        // just in case we want to increase concurrency in future
        const queue = new _pqueue.default({
            concurrency: 1
        });
        const attachments = [];
        const errors = [];
        if (!((_param_files = param.files) == null ? void 0 : _param_files.length)) {
            _catchError.NcError.badRequest('No attachment provided!');
        }
        queue.addAll((_param_files1 = param.files) == null ? void 0 : _param_files1.map((file)=>async ()=>{
                try {
                    var _param_path_toString, _param_path;
                    const nanoId = (0, _nanoid.nanoid)(5);
                    const filePath = this.sanitizeUrlPath([
                        ...(param == null ? void 0 : (_param_path = param.path) == null ? void 0 : (_param_path_toString = _param_path.toString()) == null ? void 0 : _param_path_toString.split('/')) || [
                            ''
                        ],
                        ...param.scope ? [
                            nanoId
                        ] : []
                    ]);
                    const destPath = param.scope ? _path.default.join(_destPath, `${nanoId}`) : _destPath;
                    const originalName = (0, _stringHelpers.utf8ify)(file.originalname);
                    const fileName = param.scope ? `${normalizeFilename(_path.default.parse(originalName).name)}${_path.default.extname(originalName)}` : `${normalizeFilename(_path.default.parse(originalName).name)}_${(0, _nanoid.nanoid)(5)}${_path.default.extname(originalName)}`;
                    const tempMetadata = {};
                    if (file.mimetype.includes('image')) {
                        const sharp = _Noco.default.sharp;
                        if (sharp) {
                            try {
                                const metadata = await sharp(file.path, {
                                    limitInputPixels: false
                                }).metadata();
                                if (metadata.width && metadata.height) {
                                    tempMetadata.width = metadata.width;
                                    tempMetadata.height = metadata.height;
                                }
                            } catch (e) {
                                this.logger.error(`${file.path} is not an image file`);
                            }
                        }
                    }
                    const url = await storageAdapter.fileCreate((0, _slash.default)(_path.default.join(destPath, fileName)), file);
                    await _models.FileReference.insert({
                        workspace_id: _globals.RootScopes.ROOT,
                        base_id: _globals.RootScopes.ROOT
                    }, {
                        storage: storageAdapter.name,
                        file_url: url != null ? url : _path.default.join('download', filePath.join('/'), fileName),
                        file_size: file.size,
                        fk_user_id: userId,
                        deleted: true
                    });
                    const attachment = _extends({}, url ? {
                        url
                    } : {
                        path: _path.default.join('download', filePath.join('/'), fileName)
                    }, {
                        title: originalName,
                        mimetype: file.mimetype,
                        size: file.size,
                        icon: _mimeTypes.mimeIcons[_path.default.extname(originalName).slice(1)] || undefined
                    }, tempMetadata);
                    await _models.PresignedUrl.signAttachment({
                        attachment
                    });
                    attachments.push(attachment);
                } catch (e) {
                    errors.push(e);
                }
            }));
        await queue.onIdle();
        if (errors.length) {
            errors.forEach((error)=>this.logger.error(error));
            const firstError = errors[0].error;
            if (firstError instanceof _catchError.NcError || firstError instanceof _catchError.NcBaseError) {
                throw firstError;
            }
            _catchError.NcError.internalServerError('Failed to upload attachment');
        }
        const generateThumbnail = attachments.filter((attachment)=>(0, _attachmentUtils.supportsThumbnails)(attachment));
        if (generateThumbnail.length) {
            await this.jobsService.add(_Jobs.JobTypes.ThumbnailGenerator, {
                context: {
                    base_id: _globals.RootScopes.ROOT,
                    workspace_id: _globals.RootScopes.ROOT
                },
                attachments: generateThumbnail,
                scope: param.scope
            });
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.ATTACHMENT_UPLOAD, {
            type: 'file',
            req: param.req
        });
        return attachments;
    }
    async uploadViaURL(param) {
        var _param_req_user, _param_req, _param_path_toString, _param_path, _param_urls, _param_urls_map, _param_urls1;
        // Validate scope if exist
        if (param.scope && !Object.values(_nocodbsdk.PublicAttachmentScope).includes(param.scope)) {
            _catchError.NcError.invalidAttachmentUploadScope();
        }
        const userId = ((_param_req = param.req) == null ? void 0 : (_param_req_user = _param_req.user) == null ? void 0 : _param_req_user.id) || 'anonymous';
        param.path = param.scope ? `${(0, _objecthash.default)(userId)}` : param.path || `${(0, _moment.default)().format('YYYY/MM/DD')}/${(0, _objecthash.default)(userId)}`;
        const filePath = this.sanitizeUrlPath((param == null ? void 0 : (_param_path = param.path) == null ? void 0 : (_param_path_toString = _param_path.toString()) == null ? void 0 : _param_path_toString.split('/')) || [
            ''
        ]);
        const destPath = _path.default.join('nc', param.scope ? param.scope : 'uploads', ...filePath);
        const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
        // just in case we want to increase concurrency in future
        const queue = new _pqueue.default({
            concurrency: 1
        });
        const attachments = [];
        const errors = [];
        if (!((_param_urls = param.urls) == null ? void 0 : _param_urls.length)) {
            _catchError.NcError.badRequest('No attachment provided!');
        }
        queue.addAll((_param_urls1 = param.urls) == null ? void 0 : (_param_urls_map = _param_urls1.map) == null ? void 0 : _param_urls_map.call(_param_urls1, (urlMeta)=>async ()=>{
                try {
                    var _param_path_toString, _param_path;
                    const { url, fileName: _fileName } = urlMeta;
                    const nanoId = (0, _nanoid.nanoid)(5);
                    const filePath = this.sanitizeUrlPath([
                        ...param.scope ? [
                            param.scope
                        ] : [],
                        ...(param == null ? void 0 : (_param_path = param.path) == null ? void 0 : (_param_path_toString = _param_path.toString()) == null ? void 0 : _param_path_toString.split('/')) || [
                            ''
                        ],
                        ...param.scope ? [
                            nanoId
                        ] : []
                    ]);
                    const fileDestPath = param.scope ? _path.default.join(destPath, `${nanoId}`) : destPath;
                    let mimeType, response, size, finalUrl = url;
                    let base64TempStream;
                    let base64Buffer;
                    if (!url.startsWith('data:')) {
                        var _response_headers_contenttype;
                        response = await _axios.default.head(url, {
                            maxRedirects: 5,
                            httpAgent: (0, _requestfilteringagent.useAgent)(url),
                            httpsAgent: (0, _requestfilteringagent.useAgent)(url)
                        });
                        mimeType = (_response_headers_contenttype = response.headers['content-type']) == null ? void 0 : _response_headers_contenttype.split(';')[0];
                        size = response.headers['content-length'];
                        finalUrl = response.request.res.responseUrl;
                    } else {
                        if (!url.startsWith('data')) {
                            _catchError.NcError.badRequest('Invalid data URL format');
                        }
                        const [metadata, base64Data] = url.split(',');
                        const metadataHelper = metadata.split(':');
                        if (metadataHelper.length < 2) {
                            _catchError.NcError.badRequest('Invalid data URL format');
                        }
                        const mimetypeHelper = metadataHelper[1].split(';');
                        mimeType = mimetypeHelper[0];
                        size = Buffer.byteLength(base64Data, 'base64');
                        base64Buffer = Buffer.from(base64Data, 'base64');
                        base64TempStream = _stream.Readable.from(base64Buffer);
                    }
                    const parsedUrl = _url.default.parse(finalUrl, true);
                    const decodedPath = decodeURIComponent(parsedUrl.pathname);
                    const fileNameWithExt = _fileName || _path.default.basename(decodedPath);
                    const fileName = param.scope ? `${normalizeFilename(_path.default.parse(fileNameWithExt).name)}${_path.default.extname(fileNameWithExt)}` : `${normalizeFilename(_path.default.parse(fileNameWithExt).name)}_${(0, _nanoid.nanoid)(5)}${_path.default.extname(fileNameWithExt)}`;
                    if (!mimeType) {
                        mimeType = _lite.default.getType(_path.default.extname(fileNameWithExt).slice(1));
                    }
                    let attachmentUrl, file;
                    if (!base64TempStream) {
                        const { url: _attachmentUrl, data: _file } = await storageAdapter.fileCreateByUrl((0, _slash.default)(_path.default.join(fileDestPath, fileName)), finalUrl, {
                            fetchOptions: {
                                // The sharp requires image to be passed as buffer.);
                                buffer: mimeType.includes('image')
                            }
                        });
                        attachmentUrl = _attachmentUrl;
                        file = _file;
                    } else {
                        attachmentUrl = await storageAdapter.fileCreateByStream((0, _slash.default)(_path.default.join(fileDestPath, fileName)), base64TempStream);
                        file = base64Buffer;
                    }
                    const tempMetadata = {};
                    if (mimeType.includes('image')) {
                        const sharp = _Noco.default.sharp;
                        if (sharp) {
                            try {
                                const metadata = await sharp(file, {
                                    limitInputPixels: true
                                }).metadata();
                                if (metadata.width && metadata.height) {
                                    tempMetadata.width = metadata.width;
                                    tempMetadata.height = metadata.height;
                                }
                            } catch (e) {
                                this.logger.error(`${file.path} is not an image file`);
                            }
                        }
                    }
                    await _models.FileReference.insert({
                        workspace_id: _globals.RootScopes.ROOT,
                        base_id: _globals.RootScopes.ROOT
                    }, {
                        storage: storageAdapter.name,
                        file_url: attachmentUrl != null ? attachmentUrl : _path.default.join('download', filePath.join('/'), fileName),
                        file_size: size ? parseInt(size) : urlMeta.size,
                        fk_user_id: userId,
                        deleted: true
                    });
                    const attachment = _extends({}, attachmentUrl ? {
                        url: attachmentUrl
                    } : {
                        path: _path.default.join('download', filePath.join('/'), fileName)
                    }, {
                        title: fileNameWithExt,
                        mimetype: mimeType || urlMeta.mimetype,
                        size: size ? parseInt(size) : urlMeta.size,
                        icon: _mimeTypes.mimeIcons[_path.default.extname(fileNameWithExt).slice(1)] || undefined
                    }, tempMetadata);
                    await _models.PresignedUrl.signAttachment({
                        attachment
                    });
                    attachments.push(attachment);
                } catch (e) {
                    errors.push(e);
                }
            }));
        await queue.onIdle();
        if (errors.length) {
            errors.forEach((error)=>this.logger.error(error));
            const firstError = errors[0].error;
            if (firstError instanceof _catchError.NcError || firstError instanceof _catchError.NcBaseError) {
                throw firstError;
            }
            _catchError.NcError.internalServerError('Failed to upload attachment');
        }
        const generateThumbnail = attachments.filter((attachment)=>(0, _attachmentUtils.supportsThumbnails)(attachment));
        if (generateThumbnail.length) {
            await this.jobsService.add(_Jobs.JobTypes.ThumbnailGenerator, {
                context: {
                    base_id: _globals.RootScopes.ROOT,
                    workspace_id: _globals.RootScopes.ROOT
                },
                attachments: generateThumbnail,
                scope: param.scope
            });
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.ATTACHMENT_UPLOAD, {
            type: 'url',
            req: param.req
        });
        return attachments;
    }
    async getFile(param) {
        const type = _lite.default.getType(_path.default.extname(param.path).split('/').pop().slice(1)) || 'text/plain';
        const filePath = (0, _attachmentHelpers.validateAndNormaliseLocalPath)(param.path, true);
        return {
            path: filePath,
            type
        };
    }
    async getAttachmentFromRecord(param) {
        const { record, column, urlOrPath } = param;
        const attachment = record[column.title];
        if (!attachment || !attachment.length) {
            _catchError.NcError.genericNotFound('Attachment', urlOrPath);
        }
        const fileObject = attachment.find((a)=>a.url === urlOrPath || a.path === urlOrPath);
        if (!fileObject) {
            _catchError.NcError.genericNotFound('Attachment', urlOrPath);
        }
        await _models.PresignedUrl.signAttachment({
            attachment: fileObject,
            preview: false,
            filename: fileObject.title,
            expireSeconds: 5 * 60
        });
        return _extends({}, (fileObject == null ? void 0 : fileObject.path) ? {
            path: fileObject.signedPath
        } : {
            url: fileObject.signedUrl
        });
    }
    sanitizeUrlPath(paths) {
        return paths.map((url)=>url.replace(/[/.?#]+/g, '_'));
    }
    constructor(appHooksService, jobsService){
        this.appHooksService = appHooksService;
        this.jobsService = jobsService;
        this.logger = new _common.Logger(AttachmentsService.name);
    }
};
_ts_decorate([
    (0, _useworkerdecorator.UseWorker)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], AttachmentsService.prototype, "uploadViaURL", null);
AttachmentsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(1, (0, _common.Inject)((0, _common.forwardRef)(()=>'JobsService'))),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService
    ])
], AttachmentsService);
